export default __webpack_public_path__ + "static/web20221129-8e55681448b76427618af28423e29146.png";